import styled from 'styled-components'
import { media } from 'utils/styleUtils'
import { SPANISH_GRAY } from 'constants/colors'

export const Container = styled.div`
  display: none;

  ${media.desktop} {
    display: inline-block;
    margin-right: 0.5rem;
    width: 25px;
    height: 23px;
    vertical-align: middle;

    svg {
      width: 30px;
      height: 30px;

      g {
        stroke: ${SPANISH_GRAY};
        fill: none;
      }
    }
  }
`

function PaperAirplane() {
  return (
    <Container>
      <svg>
        <g>
          <path d="M22.4006935,0.107937647 C22.3093607,0.00953243008 22.1669485,-0.0254752596 22.0392649,0.019091493 L0.189264903,10.0263992 C0.0745607502,10.0836008 0.00173854338,10.1987906 0.00033633163,10.3252453 C-0.00570027768,10.4517379 0.0699968415,10.568239 0.189264903,10.6160146 L6.35819347,13.6044761 C6.4718963,13.6606532 6.60591922,13.6606532 6.71962205,13.6044761 L12.7242649,9.19447611 L8.01747919,13.927553 C7.94534421,13.9968332 7.91168914,14.0961101 7.92712205,14.1940915 L8.37890776,20.2113992 C8.39624682,20.3421741 8.4842691,20.4534531 8.60890776,20.5021684 L8.72390776,20.5021684 C8.82302893,20.501619 8.91660048,20.4570995 8.97855062,20.3810146 L12.2642649,16.6333223 L16.3139078,18.5960146 C16.4040192,18.6287907 16.5030821,18.6287907 16.5931935,18.5960146 C16.6849643,18.5616726 16.7549514,18.4868717 16.782122,18.3940915 L22.5074792,0.455245339 C22.5412124,0.327333573 22.4963354,0.191801949 22.3924792,0.107937647 L22.4006935,0.107937647 Z" />
        </g>
      </svg>
    </Container>
  )
}

export default PaperAirplane
